"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var moment = require("moment");
var Datetime = require("react-datetime");
var bind_1 = require("../../bind");
var mobile_detection_1 = require("../../reverb-js-common/mobile_detection");
exports.YEAR_MONTH_DAY_FORMAT = 'YYYY-MM-DD';
var CalendarInput = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarInput, _super);
    function CalendarInput(props) {
        return _super.call(this, props) || this;
    }
    CalendarInput.prototype.validOnOrAfterMinDate = function (currentDay) {
        return currentDay.isSameOrAfter(this.props.minDate, 'day');
    };
    CalendarInput.prototype.onMobileInputChange = function (event) {
        this.props.onChange(moment(event.target.value, exports.YEAR_MONTH_DAY_FORMAT));
    };
    CalendarInput.prototype.render = function () {
        if (mobile_detection_1.default.isMobileBrowser()) {
            return (React.createElement("input", { className: this.props.className, type: "date", value: this.props.currentDate.format(exports.YEAR_MONTH_DAY_FORMAT), min: this.props.minDate.format(exports.YEAR_MONTH_DAY_FORMAT), onChange: this.onMobileInputChange }));
        }
        return (React.createElement(Datetime, { className: this.props.className, value: this.props.currentDate, onChange: this.props.onChange, dateFormat: "L", timeFormat: false, isValidDate: this.validOnOrAfterMinDate }));
    };
    tslib_1.__decorate([
        bind_1.default
    ], CalendarInput.prototype, "validOnOrAfterMinDate", null);
    tslib_1.__decorate([
        bind_1.default
    ], CalendarInput.prototype, "onMobileInputChange", null);
    return CalendarInput;
}(React.Component));
exports.default = CalendarInput;
//# sourceMappingURL=calendar_input.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/calendar_input.js
// module id = 7x8j
// module chunks = 20 21